module.exports = __webpack_public_path__ + "img/tintuc8.386c1f39.png";